import { render, staticRenderFns } from "./RateClassApproval.vue?vue&type=template&id=1ec5e5d4&"
import script from "./RateClassApproval.vue?vue&type=script&lang=js&"
export * from "./RateClassApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports